import forEach from 'lodash/forEach';
import mapValues from 'lodash/mapValues';
import isEmpty from 'lodash/isEmpty';
import { langList, _langList } from "../const/lang";
import { setCookie, getCookie } from "./cookie";
import { DEFAULT_LANG, DEFAULT_COOKIE_KEY, PANDA_I18N_PACK } from "../const";
import { debugInfo } from "./log";
export * from "./log";

/** 获取当前环境os的lang */
export var getOSLang = function getOSLang() {
  var _window$_GATEWAY_PF, _window$_GATEWAY_PF$u;
  return (_window$_GATEWAY_PF = window._GATEWAY_PF) === null || _window$_GATEWAY_PF === void 0 ? void 0 : (_window$_GATEWAY_PF$u = _window$_GATEWAY_PF.userPreference) === null || _window$_GATEWAY_PF$u === void 0 ? void 0 : _window$_GATEWAY_PF$u.lang;
};

/**
 * 语种格式转换：en-US，en_US, en_us, en 全部格式化为en-US
 * @param {string} locale 语种
 */
export var formatLang = function formatLang(locale) {
  // 如果格式不正确直接返回当前的语种防止处理报错
  if (typeof locale !== 'string') {
    return getLangValue();
  }
  //  先匹配一轮, 先转成小写，并且将_转成-,然后进行匹配
  var _locale = locale.replace('_', '-');
  if (_locale.includes('-')) {
    _locale = _locale.split('-').map(function (item, index) {
      return index === 1 ? item.toUpperCase() : item;
    }).join('-');
  }
  var _slocale = _locale.toLowerCase();
  var theLang = _langList.find(function (item) {
    return item.value === _locale || (typeof item.s === 'string' ? item.s === _slocale : item.s.includes(_slocale));
  });
  if (theLang) {
    return theLang.value;
  }
  // 处理特殊的 zh-Hans 和 zh-Hant
  if (locale.startsWith('zh-Hans')) {
    return 'zh-CN';
  }
  if (locale.startsWith('zh-Hant')) {
    return locale === 'zh-Hant-TW' ? 'zh-TW' : 'zh-HK';
  }
  // 处理 en-
  if (locale.startsWith('en-')) {
    return 'en-US';
  }
  return locale;
};

/**
 * 获取cookie中语种的值
 */
export var getLangValue = function getLangValue(options) {
  var _window$__PANDA, _window$__PANDA2, _window$__PANDA3, _window$__PANDA4, _window$__PANDA5, _document, _document$cookie, _window$__PANDA$langL;
  if (options === void 0) {
    options = {};
  }
  // 取出来的值可能并不是语种，需要格式化
  var _options = options,
    lang = _options.lang;
  var cookieKey = ((_window$__PANDA = window.__PANDA) === null || _window$__PANDA === void 0 ? void 0 : _window$__PANDA.cookieKey) || DEFAULT_COOKIE_KEY;
  // 获取CDN给予的cookieKey, 如果没有默认走x-hng
  var customLang = cookieKey !== DEFAULT_COOKIE_KEY && getCookie(cookieKey) ? getCookieLang(cookieKey) : '';
  var xhngLang = cookieKey === DEFAULT_COOKIE_KEY && getCookie(DEFAULT_COOKIE_KEY) ? getCookieLang(DEFAULT_COOKIE_KEY) : '';
  var windowLang = (_window$__PANDA2 = window.__PANDA) === null || _window$__PANDA2 === void 0 ? void 0 : _window$__PANDA2.lang;
  var searchLang = (_window$__PANDA3 = window.__PANDA) === null || _window$__PANDA3 === void 0 ? void 0 : _window$__PANDA3.searchLang;
  var localLang = (_window$__PANDA4 = window.__PANDA) === null || _window$__PANDA4 === void 0 ? void 0 : _window$__PANDA4.localLang;
  var defaultLang = (_window$__PANDA5 = window.__PANDA) === null || _window$__PANDA5 === void 0 ? void 0 : _window$__PANDA5.defaultLang;
  var matchXhng = (_document = document) === null || _document === void 0 ? void 0 : (_document$cookie = _document.cookie) === null || _document$cookie === void 0 ? void 0 : _document$cookie.match(/x-hng/g);
  // TODO 使用domain作为权重判断不再使用ls辅助
  var isMultiXhng = matchXhng && Array.isArray(matchXhng) && matchXhng.length > 1;
  var osLang = getOSLang();
  // 当x-hng冲突时（存在多个的情况） 提升localLang的权重
  debugInfo("isMultiXhng: " + (isMultiXhng ? 'true' : 'false') + "; lang: " + lang + " || searchLang: " + searchLang + " || osLang: " + osLang + " || customLang: " + customLang + " || localLang: " + localLang + " || xhngLang: " + xhngLang + " || windowLang: " + windowLang);
  var usedLang = lang || searchLang || osLang || customLang || (isMultiXhng ? localLang || xhngLang : xhngLang || localLang) || defaultLang || windowLang || DEFAULT_LANG;
  usedLang = formatLang(usedLang);
  // 如果全局设置的langList（允许语种），则最终会受限制
  if ((_window$__PANDA$langL = window.__PANDA.langList) !== null && _window$__PANDA$langL !== void 0 && _window$__PANDA$langL.length && !window.__PANDA.langList.includes(usedLang)) {
    usedLang = window.__PANDA.langList[0];
  }
  debugInfo("isMultiXhng Result: " + usedLang);
  return usedLang;
};
export function getRandomKey() {
  return Math.random().toString(36).slice(2);
}
export function inLang(lang) {
  return !!langList.find(function (item) {
    return item.value === lang;
  });
}
export function convertPandaI18nFormatToLocalResource(pandaString) {
  var pandaFormat = {};
  forEach(pandaString, function (v, k) {
    pandaFormat[formatLang(k)] = mapValues(v.copyList, function (item) {
      return item.content;
    });
  });
  return pandaFormat;
}

/** 如果非x-hng则设置值，x-hng只处理lang部分 */
export function setCookieLang(lang) {
  if (window.__PANDA.cookieKey === DEFAULT_COOKIE_KEY) {
    var xhngValue = getCookie(DEFAULT_COOKIE_KEY);
    if (!xhngValue) {
      setCookie(DEFAULT_COOKIE_KEY, "lang=" + lang + "&domain=" + window.location.hostname);
    } else {
      var newUrlP = new URLSearchParams();
      new URLSearchParams(xhngValue).forEach(function (v, k) {
        if (k === 'lang') {
          newUrlP.set(k, lang);
        } else {
          newUrlP.set(k, v);
        }
      });
      newUrlP.set('domain', window.location.hostname);
      setCookie(DEFAULT_COOKIE_KEY, newUrlP.toString());
    }
  } else {
    setCookie(window.__PANDA.cookieKey, lang);
  }
}

/** 如果非x-hng则返回值，x-hng则返回lang部分的值 */
export function getCookieLang(key) {
  if (key === DEFAULT_COOKIE_KEY) {
    return new URLSearchParams(getCookie(DEFAULT_COOKIE_KEY)).get('lang') || DEFAULT_LANG;
  }
  return getCookie(key) || DEFAULT_LANG;
}
export function getNavigatorLang() {
  if (typeof navigator !== 'undefined') {
    var navigatorLanguage = navigator.language;
    // Compatible with dingding
    if (navigator.userAgent.includes('DingTalk')) {
      var lanuageMatch = navigator.userAgent.match(/language\/([a-zA-Z-]+)/);
      if (lanuageMatch && lanuageMatch !== null && lanuageMatch !== void 0 && lanuageMatch[1]) {
        navigatorLanguage = lanuageMatch[1];
      }
    }
    if (inLang(formatLang(navigatorLanguage))) {
      return formatLang(navigatorLanguage);
    }
    return navigator.languages.find(function (_lang) {
      return inLang(_lang);
    });
  }
  return DEFAULT_LANG;
}
export function langToShortLang(lang) {
  var theLang = _langList.find(function (item) {
    return item.value === lang;
  });
  if (theLang) {
    return typeof theLang.s === 'string' ? theLang.s : theLang.s[0];
  }
  return lang.split('-')[0].toLocaleLowerCase();
}

// cdn 语言包设置的cookieKey 存在多个语言包挂载的cookieKey不同的情况, 当前按第一个设置为准

/** 通过当前的挂载的语言包的情况设置cookieKey */
export function setCookieKey() {
  if (Object.keys(window[PANDA_I18N_PACK]).length) {
    var langCookieName = Object.values(window[PANDA_I18N_PACK])[0].langCookieName;
    if (langCookieName && window.__PANDA.cookieKey === DEFAULT_COOKIE_KEY) {
      window.__PANDA.cookieKey = langCookieName;
    }
  }
}

/** 合并两个locale，兼容新老语种模式（合并后会变成新的） */
export function mergeLocale(oldLocale, newLocale, useOldInstance) {
  if (useOldInstance === void 0) {
    useOldInstance = true;
  }
  if (isEmpty(newLocale)) {
    return oldLocale;
  }
  if (useOldInstance) {
    forEach(newLocale, function (v, k) {
      oldLocale[formatLang(k)] = v;
    });
  }
  var newLocalResource = {};
  forEach(newLocale, function (v, k) {
    newLocalResource[formatLang(k)] = v;
  });
  forEach(oldLocale, function (v, k) {
    newLocalResource[formatLang(k)] = v;
  });
  return newLocalResource;
}